<template v-if="detailData">
  <dx-tab-panel>
    <dx-item
      title="Fundings"
      template="funding-tab"
    >
    </dx-item>
    <funding-tab
      slot="funding-tab"
      :fundingData="detailData"
    />
  </dx-tab-panel>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import {
    DxTabPanel,
    DxItem
  } from 'devextreme-vue/tab-panel'
  import FundingTab from '@/components/fundings/FundingTab.vue'

  export default {
    name: 'fundingMasterDetail',
    components: {
      DxTabPanel,
      DxItem,
      FundingTab
    },
    props: {
      masterDetailData: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        hasError: false,
        errorMessage: '',
        isBusy: false,
        detailData: undefined
      }
    },
    created () {
      if (this.masterDetailData.data.profile.cRM_Adress_id !== null) {
        this.getFundingsDetail(this.masterDetailData.data.profile.cRM_Adress_id)
      }
    },
    methods: {
      async getFundingsDetail (id) {
        this.hasError = false
        this.isBusy = true

        try {
          const { errors } = await this.$store.dispatch('fundings/GET_FUNDING_BY_ID', { id })
          if (errors) throw errors
          this.isBusy = false
          this.detailData = this.fundingDetail
        } catch (err) {
          this.isBusy = false
          this.hasError = true
          this.errorMessage = this.$t('formError.unknownwError')
          console.error(err)
        }
      }
    },
    computed: {
      ...mapGetters({ fundingDetail: 'fundings/FUNDINGS_DETAIL' }),
      ...mapState({
        currentUser: state => state.user.currentUser
      })
    }
  }
</script>
<style lang="scss">
.dx-datagrid-rowsview .dx-row > .dx-master-detail-cell{
  padding: 5px;
}
</style>
